const metaEnv = import.meta.env;

export class AppEnv {
  constructor(
    public readonly feHost: string,
    public readonly apiHost: string,
    public readonly microsoftGraphUrl: string
  ) { }
}

export const appEnvs: Record<string, AppEnv> = {
  default: new AppEnv(
    metaEnv.VITE_FE_HOST,
    metaEnv.VITE_API_HOST,
    metaEnv.VITE_MICROSOFT_GRAPH_URL
  ),
  'suckhoegiadinhviet-dev-cms.ajinomoto.com.vn': new AppEnv(
    metaEnv.VITE_FE_HOST,
    metaEnv.VITE_API_HOST,
    metaEnv.VITE_MICROSOFT_GRAPH_URL
  ),
  'suckhoegiadinhviet-dev2-cms.ajinomoto.com.vn': new AppEnv(
    metaEnv.VITE_STAGING_HOST,
    metaEnv.VITE_STAGING_API_HOST,
    metaEnv.VITE_MICROSOFT_GRAPH_URL
  ),
  'suckhoegiadinhviet-cms.ajinomoto.com.vn': new AppEnv(
    metaEnv.VITE_PROD_FE_HOST,
    metaEnv.VITE_PROD_API_HOST,
    metaEnv.VITE_MICROSOFT_GRAPH_URL
  )
};